import request from "@/api/Request";

let baseUrl = "/api/v1/booking";
let BookingConfirmApi = {
    detail(code) {
        return request.get(
            baseUrl + "/detail?code=" + code,
            {
                headers: {
                    'Content-Type': undefined
                }
            }
        )
    },
    cancel(code) {
        let formData = new FormData();
        formData.append("code", code)
        return request.put(
            baseUrl + "/end-user/cancel", formData,
            {
                headers: {
                    'Content-Type': undefined
                }
            }
        )
    },
    getEndUserBooking() {
        return request.get(
            baseUrl + "/getEndUserBooking",
            {
                headers: {
                    'Content-Type': undefined
                }
            }
        )
    },
    getEndUserOldBooking() {
        return request.get(
            baseUrl + "/getEndUserOldBooking",
            {
                headers: {
                    'Content-Type': undefined
                }
            }
        )
    },
    getWarning() {
        return request.get(
            baseUrl + "/getBookingCancelWarning",
            {
                headers: {
                    'Content-Type': undefined
                }
            }
        )
    }
};

export default BookingConfirmApi;
